import * as types from './mutation-types.js'

import {
  setStore,
  getStore
} from '../config/mUtils'

export default {

  //删除地址列表
  [types.SAVE_ADDRESS](state, newAdress) {
    state.removeAddress = newAdress
  },
  //保存搜索信息
  [types.SAVE_SEARCHKEY](state, searchKey) {
    state.searchKey = searchKey
  },
  //设置购物车商品数量
  [types.SAVE_CARTLIST](state, cartList) {
    state.cartList = cartList
  },
  //设置商品分类ID
  [types.SAVE_CATEGORYTYPE](state, categoryType) {
    state.categoryType = categoryType
  },
  //设置当前城市
  [types.SAVE_ACTIVECITY](state, activeCity) {
    state.activeCity = activeCity
  },
  //设置订单列表
  [types.SAVE_ORDERLIST](state, orderList) {
    state.orderList = orderList
  },
  //设置滚动条位置
  [types.SET_POSITION](state, routeName) {
    state.arrPageName=routeName
    for(const attr in state.position){
      if(routeName==attr){
        setTimeout(()=>{state.position[attr].scroller.scrollTo(state.position[attr].pos.left,state.position[attr].pos.top)},10)
      }
    }
  },
  //设置滚动条位置
  [types.SAVE_PAGE](state,{pos, scroller}) {
    state.position[state.arrPageName]={pos:pos,scroller:scroller}
  },
  //设置所在地址
  [types.SET_ACTIVELOCAL](state,{acitiveLocal, acitiveLocalNo}) {
    state.acitiveLocal=acitiveLocal
    state.acitiveLocalNo=acitiveLocalNo

  }
}



// WEBPACK FOOTER //
// ./src/story/mutations.js